import React, { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { api } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";

let _cache = null;
export function useMaintenance() {
  const [flags, setFlags] = useState(_cache?.maintenance || null);
  const [messages, setMessages] = useState(_cache?.messages || null);
  useEffect(() => {
    if (_cache) { setFlags(_cache.maintenance); setMessages(_cache.messages); return; }
    api.get("/platform/flags").then(({ data }) => {
      _cache = data; setFlags(data.maintenance); setMessages(data.messages);
    }).catch(() => { setFlags({}); setMessages(null); });
  }, []);
  return { flags: flags || {}, messages };
}

export function MaintenanceNotice({ area, className = "" }) {
  const { flags, messages } = useMaintenance();
  const { lang } = useLanguage();
  if (!flags[area]) return null;
  const m = (messages && (messages[lang] || messages.en)) || {
    title: "WE'RE PREPARING SOMETHING EXTRAORDINARY",
    body: "Some TAVEN features may be temporarily unavailable while we complete maintenance and final platform improvements. We'll be back soon with an extraordinary business ecosystem designed to serve you better.\n\nThank you for your patience. Stay tuned!",
  };
  return (
    <div data-testid={`maintenance-notice-${area}`}
      className={`relative overflow-hidden bg-taven-black text-white border border-taven-gold/40 px-5 py-6 sm:px-8 sm:py-8 ${className}`}>
      <div className="absolute -right-6 -top-6 opacity-10"><Wrench className="w-28 h-28 text-taven-gold" /></div>
      <div className="relative max-w-3xl">
        <span className="inline-block bg-taven-gold text-taven-black text-[10px] font-black uppercase tracking-[0.2em] px-3 py-1 mb-3">TAVEN</span>
        <h2 className="font-display font-black text-xl sm:text-2xl text-taven-gold mb-3">{m.title}</h2>
        {m.body.split("\n\n").map((p, i) => (
          <p key={i} className="text-white/80 text-sm sm:text-base leading-relaxed mb-2">{p}</p>
        ))}
      </div>
    </div>
  );
}

// helper: is a paid/operational action blocked by maintenance?
export function useBlocked(area) {
  const { flags } = useMaintenance();
  return !!flags[area];
}
